module.exports = __webpack_public_path__ + "img/depmap_svg_V124.07e47686.svg";